module.exports = __webpack_public_path__ + "static/media/photo249.d12c8c50.jpg";